import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';

export const AmcDetailSkelton = (): JSX.Element => {
    return (
        <div className="all-mfs-outer">
            <div className="all-mfs">
                {new Array(5).fill(0).map((_, index) => (
                    <a className="all-mfs-info">
                        <Skeleton
                            key={index}
                            animation="wave"
                            height={40}
                            width={40}
                            variant="rect"
                        />
                        <div className="mf-category-content">
                            <Skeleton key={index} animation="wave" height={25} variant="text" />
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export const NewPurchaseSkelton = ({
    height = 80,
    className = 'all-mfs-info',
}: any): JSX.Element => {
    return (
        <>
            {new Array(5).fill(0).map((_, index) => (
                <Skeleton
                    key={index}
                    animation="wave"
                    height={height}
                    variant="rect"
                    className={className}
                />
            ))}
        </>
    );
};

export const TitleSkelton = (props: any) => {
    return <Skeleton animation="wave" variant="text" {...props} />;
};

export const SchemeDetailHeaderSkelton = () => {
    return (
        <>
            <div className="list-cards-image">
                <Skeleton height={50} animation="wave" variant="rect" />
            </div>
            <div className="explore-mf-details-fund-heading">
                <Skeleton
                    width={400}
                    animation="wave"
                    variant="text"
                    className="explore-mf-details-fund-name"
                />
                <div className="explore-mf-details-fund-tags">
                    <Skeleton animation="wave" variant="text" className="tags" width={100} />
                </div>
            </div>
        </>
    );
};

export const SchemeListCardSkelton = () => {
    return (
        <>
            {new Array(6).fill({}).map((_, index) => (
                <a className="mf-filters-info" style={{ marginTop: 0 }}>
                    <div className="logo">
                        <Skeleton
                            variant="rect"
                            width={50}
                            height={50}
                            style={{ marginRight: 30 }}
                        />
                    </div>
                    <div className="mf-filters-title">
                        <h4>
                            <Skeleton variant="text" width={300} height={20} />
                        </h4>
                        <div style={{ display: 'flex' }}>
                            <Skeleton
                                variant="text"
                                width={60}
                                height={18}
                                style={{ marginRight: 20 }}
                            />
                            <Skeleton variant="text" width={60} height={18} />
                        </div>
                    </div>
                    <div className="mf-filters-info-right">
                        <div className="mf-filters-percent">
                            <h6>
                                <Skeleton variant="text" width={50} height={20} />
                            </h6>
                            <p>
                                <Skeleton variant="text" width={50} height={20} />
                            </p>
                        </div>
                    </div>
                </a>
            ))}
        </>
    );
};
